import React from 'react';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { IconLink } from '../../../atoms/iconLink/IconLink';
import { Row } from '../../../atoms/row/Row';

const FooterSection = ({ data }) => (
  <Stack className="gap-4">
    <Typography textAlign="left" fontVariant="h8" className="font-bold">
      {data.title}
    </Typography>
    <Stack className="gap-1 items-start">
      {data.componentData?.map((link) => (
        <LinkButton
          variant="transparent"
          className="pl-0 py-1 text-clamp-sm !text-customGray-500"
          key={link.name}
          href={link.href}
          label={link.name}
          external={link.href.includes('://')}
          trackingFn={() => {}}
        />
      ))}
    </Stack>
  </Stack>
);

const Footer = ({ data, preview }) => {
  const findSectionByType = (type) =>
    data.footerItems?.find((section) => section.component.type === type)
      ?.component || [];

  const logoSection = findSectionByType('logoSection');
  const menuLinks1 = findSectionByType('menuLinks1');
  const menuLinks2 = findSectionByType('menuLinks2');
  const menuLinks = findSectionByType('menuLinks');
  const sites = findSectionByType('sites');

  return (
    <div
      className={`flex bg-[#EFF4F9] ${
        preview ? 'pointer-events-none opacity-30' : ''
      }`}
    >
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[350px_repeat(3,_1fr)] gap-10 mx-auto px-8 max-w-7xl my-10">
        <Stack className="gap-6 md:pr-10">
          <IconLink title="BusinessWith logo" className="w-fit" href="/">
            {logoSection.componentData.logoImg}
          </IconLink>
          <div>
            <Typography
              fontVariant="sm"
              textAlign="left"
              className="!text-customGray-500"
            >
              {data.bwName}
            </Typography>
            {data.bwMail && (
              <a
                href={`mailto:${data.bwMail}`}
                className="text-clamp-sm font-light !text-customGray-900"
              >
                {data.bwMail}
              </a>
            )}
            {data.bwCtaUrl && data.bwCtaLabel && (
              <LinkButton
                variant="transparent"
                // variant="primary-outlined"
                textTransform="uppercase"
                // className="pl-0 py-1 text-clamp-sm !text-customGray-500"
                className="px-0 my-3 !text-customGray-500"
                key={data.bwCtaLabel}
                href={data.bwCtaUrl}
                label={data.bwCtaLabel}
                external={false}
                trackingFn={() => {}}
              />
            )}
          </div>
          {data?.addresses?.map((address) => (
            <Typography
              fontVariant="sm"
              textAlign="left"
              className="!text-customGray-500"
              key={address?.zip?.trim()}
            >
              {address?.street}
              <br />
              {address?.zip} {address?.city}
            </Typography>
          ))}

          {/*
          <Typography
            fontVariant="sm"
            textAlign="left"
            className="!text-customGray-500"
          >
            {logoSection.componentData.text}
          </Typography>
          */}

          {/* <LinkButton
            borderRadius="sm"
            variant="transparent"
            textTransform="uppercase"
            className="border border-customGray-900 !text-clamp-button text-center !text-customGray-900"
            label={logoSection.componentData.buttonNewsLetter}
          /> */}
          <Row className="flex gap-6">
            {logoSection.componentData.iconsSocial.map((icon) => (
              <IconLink title={icon.name} key={icon.name} href={icon.iconUrl}>
                {icon.iconImg}
              </IconLink>
            ))}
          </Row>
        </Stack>
        <FooterSection data={menuLinks} />
        <FooterSection data={menuLinks1} />
        <FooterSection data={menuLinks2} />

        <div className="flex gap-6 col-span-full row-end-auto justify-center">
          <div className="flex gap-6">
            {sites?.componentData?.map((site) => (
              <a
                key={site.locale}
                href={site.url}
                target="_blank"
                rel="noopener"
                aria-label={`Go to ${site.locale} site`}
              >
                <img
                  className="md:grayscale md:hover:grayscale-0 transition-all duration-300 cursor-pointer"
                  src={site.imgUrl}
                  alt={`Go to ${site.locale} site`}
                  width="28"
                  height="28"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;

/**
 * 
 * {data.sites?.map((site, index) => {
              return (
                <a key={index}>
                  <img
                    className="grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer"
                    src={site.url}
                    width="28"
                  />
                </a>
              );
            })}
 */
